import { render, staticRenderFns } from "./IntellectualPropertyPolicy.pug?vue&type=template&id=eb1e243c&lang=pug&"
import script from "./IntellectualPropertyPolicy.vue?vue&type=script&lang=js&"
export * from "./IntellectualPropertyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports